import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../../components/ui/Header';
import MobileNav from '../../components/ui/MobileNav';
import QuickActions from '../../components/ui/QuickActions';
import FilterPanel from './components/FilterPanel';
import InfluencerCard from './components/InfluencerCard';
import ComparisonModal from './components/ComparisonModal';
import SearchBar from './components/SearchBar';
import SortControls from './components/SortControls';
import Icon from '../../components/AppIcon';
import ProposalModal from '../influencer-profile/components/ProposalModal';
import { useAuth } from '../../contexts/AuthContext';

const InfluencerDiscovery = () => {
  const { user, openLoginModal } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(searchParams?.get('search') || '');
  const [sortBy, setSortBy] = useState('relevance');
  const [viewMode, setViewMode] = useState('grid');
  const [compareList, setCompareList] = useState([]);
  const [isComparisonOpen, setIsComparisonOpen] = useState(false);
  const [isProposalModalOpen, setIsProposalModalOpen] = useState(false);
  const [selectedInfluencer, setSelectedInfluencer] = useState(null);
  const [filters, setFilters] = useState({
    followerRange: 'all',
    engagementRange: 'all',
    contentTypes: [],
    platforms: [],
    demographics: [],
    minPrice: '',
    maxPrice: '',
    verified: false
  });

  const mockInfluencers = [
  {
    id: 1,
    name: "Ayşe Yılmaz",
    username: "ayse_music",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16fb866e4-1763297510342.png",
    avatarAlt: "Professional headshot of young Turkish woman with long brown hair wearing casual denim jacket",
    coverImage: "https://images.unsplash.com/photo-1659958661414-59d7bd483853",
    coverImageAlt: "Modern music studio setup with professional microphone and recording equipment in warm lighting",
    followers: 125000,
    engagementRate: 6.8,
    avgViews: 85000,
    avgLikes: 8500,
    platforms: ['instagram', 'tiktok'],
    categories: ['Pop Müzik', 'R&B', 'Akustik'],
    startingPrice: 2500,
    verified: true,
    isOnline: true,
    isFavorited: false,
    responseTime: "2 saat",
    completedCampaigns: 47,
    rating: 4.9
  },
  {
    id: 2,
    name: "Mehmet Demir",
    username: "mehmet_beats",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19d1a8b4f-1763296407972.png",
    avatarAlt: "Professional portrait of Turkish man with short black hair and beard wearing black t-shirt",
    coverImage: "https://images.unsplash.com/photo-1724452144052-551040c68c2d",
    coverImageAlt: "DJ mixing console with colorful LED lights and professional audio equipment in dark club setting",
    followers: 89000,
    engagementRate: 5.2,
    avgViews: 62000,
    avgLikes: 4600,
    platforms: ['youtube', 'instagram'],
    categories: ['Hip Hop', 'Trap', 'Elektronik'],
    startingPrice: 1800,
    verified: true,
    isOnline: false,
    isFavorited: true,
    responseTime: "4 saat",
    completedCampaigns: 32,
    rating: 4.7
  },
  {
    id: 3,
    name: "Zeynep Kaya",
    username: "zeynep_vocals",
    avatar: "https://images.unsplash.com/photo-1730177201736-318e8cb8c337",
    avatarAlt: "Artistic portrait of young woman with curly dark hair wearing elegant black dress",
    coverImage: "https://images.unsplash.com/flagged/photo-1572372983589-b12727fc8df7",
    coverImageAlt: "Female singer performing on stage with dramatic purple and blue stage lighting",
    followers: 256000,
    engagementRate: 8.5,
    avgViews: 180000,
    avgLikes: 21700,
    platforms: ['instagram', 'tiktok', 'youtube'],
    categories: ['Caz', 'Soul', 'Blues'],
    startingPrice: 4200,
    verified: true,
    isOnline: true,
    isFavorited: false,
    responseTime: "1 saat",
    completedCampaigns: 68,
    rating: 5.0
  },
  {
    id: 4,
    name: "Can Özdemir",
    username: "can_producer",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b7634b59-1763292776008.png",
    avatarAlt: "Professional photo of young Turkish man with styled hair wearing white shirt in studio",
    coverImage: "https://images.unsplash.com/photo-1695988549009-b994fa743124",
    coverImageAlt: "Professional music production studio with multiple monitors and synthesizers in modern setup",
    followers: 67000,
    engagementRate: 4.3,
    avgViews: 45000,
    avgLikes: 2900,
    platforms: ['youtube', 'twitter'],
    categories: ['Elektronik', 'House', 'Techno'],
    startingPrice: 1500,
    verified: false,
    isOnline: true,
    isFavorited: false,
    responseTime: "6 saat",
    completedCampaigns: 23,
    rating: 4.5
  },
  {
    id: 5,
    name: "Elif Şahin",
    username: "elif_indie",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15b2344d8-1763300671052.png",
    avatarAlt: "Casual portrait of young woman with short blonde hair wearing vintage band t-shirt",
    coverImage: "https://images.unsplash.com/photo-1571525030641-5be2251e9ebc",
    coverImageAlt: "Indie music concert with guitarist performing under warm stage lights with crowd silhouettes",
    followers: 143000,
    engagementRate: 7.1,
    avgViews: 95000,
    avgLikes: 10100,
    platforms: ['instagram', 'tiktok'],
    categories: ['Indie', 'Alternative', 'Rock'],
    startingPrice: 2800,
    verified: true,
    isOnline: false,
    isFavorited: true,
    responseTime: "3 saat",
    completedCampaigns: 41,
    rating: 4.8
  },
  {
    id: 6,
    name: "Burak Yıldız",
    username: "burak_rap",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d110b160-1763293921593.png",
    avatarAlt: "Urban portrait of young man with cap and streetwear clothing in city environment",
    coverImage: "https://images.unsplash.com/photo-1571310100246-e0676f359b42",
    coverImageAlt: "Hip hop artist performing on stage with microphone under dramatic red and blue lighting",
    followers: 198000,
    engagementRate: 6.2,
    avgViews: 125000,
    avgLikes: 12300,
    platforms: ['instagram', 'youtube', 'tiktok'],
    categories: ['Rap', 'Hip Hop', 'Trap'],
    startingPrice: 3500,
    verified: true,
    isOnline: true,
    isFavorited: false,
    responseTime: "2 saat",
    completedCampaigns: 55,
    rating: 4.9
  },
  {
    id: 7,
    name: "Selin Arslan",
    username: "selin_acoustic",
    avatar: "https://images.unsplash.com/photo-1615890557765-27311dd6d5b7",
    avatarAlt: "Natural portrait of woman with long dark hair holding acoustic guitar outdoors",
    coverImage: "https://images.unsplash.com/photo-1708246308126-cc5c6184787a",
    coverImageAlt: "Acoustic guitar close-up with warm wooden tones and strings in soft natural lighting",
    followers: 78000,
    engagementRate: 5.8,
    avgViews: 52000,
    avgLikes: 4500,
    platforms: ['instagram', 'youtube'],
    categories: ['Akustik', 'Folk', 'Singer-Songwriter'],
    startingPrice: 1900,
    verified: false,
    isOnline: true,
    isFavorited: false,
    responseTime: "5 saat",
    completedCampaigns: 28,
    rating: 4.6
  },
  {
    id: 8,
    name: "Emre Koç",
    username: "emre_edm",
    avatar: "https://images.unsplash.com/photo-1722520495436-b339fb4340f3",
    avatarAlt: "Energetic portrait of young DJ with headphones around neck in neon-lit club environment",
    coverImage: "https://images.unsplash.com/photo-1658843343904-0341c4400c25",
    coverImageAlt: "Electronic music festival stage with massive LED screens and colorful laser light show",
    followers: 312000,
    engagementRate: 7.9,
    avgViews: 245000,
    avgLikes: 24600,
    platforms: ['instagram', 'tiktok', 'youtube', 'twitter'],
    categories: ['EDM', 'Progressive House', 'Trance'],
    startingPrice: 5000,
    verified: true,
    isOnline: false,
    isFavorited: true,
    responseTime: "1 saat",
    completedCampaigns: 82,
    rating: 5.0
  }];


  const [filteredInfluencers, setFilteredInfluencers] = useState(mockInfluencers);

  useEffect(() => {
    applyFiltersAndSort();
  }, [filters, sortBy, searchQuery]);

  const applyFiltersAndSort = () => {
    let results = [...mockInfluencers];

    if (searchQuery) {
      const query = searchQuery?.toLowerCase();
      results = results?.filter((inf) =>
      inf?.name?.toLowerCase()?.includes(query) ||
      inf?.username?.toLowerCase()?.includes(query) ||
      inf?.categories?.some((cat) => cat?.toLowerCase()?.includes(query))
      );
    }

    if (filters?.followerRange !== 'all') {
      const ranges = {
        '1k-10k': [1000, 10000],
        '10k-50k': [10000, 50000],
        '50k-100k': [50000, 100000],
        '100k-500k': [100000, 500000],
        '500k+': [500000, Infinity]
      };
      const [min, max] = ranges?.[filters?.followerRange];
      results = results?.filter((inf) => inf?.followers >= min && inf?.followers <= max);
    }

    if (filters?.engagementRange !== 'all') {
      const ranges = {
        '1-3': [1, 3],
        '3-5': [3, 5],
        '5-8': [5, 8],
        '8+': [8, Infinity]
      };
      const [min, max] = ranges?.[filters?.engagementRange];
      results = results?.filter((inf) => inf?.engagementRate >= min && inf?.engagementRate <= max);
    }

    if (filters?.platforms?.length > 0) {
      results = results?.filter((inf) =>
      filters?.platforms?.some((platform) => inf?.platforms?.includes(platform))
      );
    }

    if (filters?.minPrice) {
      results = results?.filter((inf) => inf?.startingPrice >= parseInt(filters?.minPrice));
    }

    if (filters?.maxPrice) {
      results = results?.filter((inf) => inf?.startingPrice <= parseInt(filters?.maxPrice));
    }

    if (filters?.verified) {
      results = results?.filter((inf) => inf?.verified);
    }

    switch (sortBy) {
      case 'followers-desc':
        results?.sort((a, b) => b?.followers - a?.followers);
        break;
      case 'followers-asc':
        results?.sort((a, b) => a?.followers - b?.followers);
        break;
      case 'engagement-desc':
        results?.sort((a, b) => b?.engagementRate - a?.engagementRate);
        break;
      case 'engagement-asc':
        results?.sort((a, b) => a?.engagementRate - b?.engagementRate);
        break;
      case 'price-desc':
        results?.sort((a, b) => b?.startingPrice - a?.startingPrice);
        break;
      case 'price-asc':
        results?.sort((a, b) => a?.startingPrice - b?.startingPrice);
        break;
      case 'rating-desc':
        results?.sort((a, b) => b?.rating - a?.rating);
        break;
      default:
        break;
    }

    setFilteredInfluencers(results);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query) {
      setSearchParams({ search: query });
    } else {
      setSearchParams({});
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleFilterReset = () => {
    setFilters({
      followerRange: 'all',
      engagementRange: 'all',
      contentTypes: [],
      platforms: [],
      demographics: [],
      minPrice: '',
      maxPrice: '',
      verified: false
    });
  };

  const handleFavorite = (influencerId) => {
    if (!user) {
      openLoginModal();
      return;
    }
    console.log('Favorited:', influencerId);
  };

  const handleCompare = (influencerId) => {
    setCompareList((prev) => {
      if (prev?.includes(influencerId)) {
        return prev?.filter((id) => id !== influencerId);
      }
      if (prev?.length >= 4) {
        return prev;
      }
      return [...prev, influencerId];
    });
  };

  const handleRemoveFromCompare = (influencerId) => {
    setCompareList((prev) => prev?.filter((id) => id !== influencerId));
  };

  const comparedInfluencers = mockInfluencers?.filter((inf) => compareList?.includes(inf?.id));

  const openProposalModal = (influencer) => {
    if (!user) {
      openLoginModal();
      return;
    }
    setSelectedInfluencer(influencer);
    setIsProposalModalOpen(true);
  };

  const closeProposalModal = () => {
    setIsProposalModalOpen(false);
    setSelectedInfluencer(null);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16 pb-20 md:pb-6">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Influencer Keşfet
            </h1>
            <p className="text-muted-foreground">
              Müziğinizi tanıtmak için en uygun influencer'ları bulun ve kampanyalarınızı başlatın
            </p>
          </div>

          <div className="mb-6">
            <SearchBar
              onSearch={handleSearch}
              onFilterToggle={() => setIsFilterOpen(true)} />

          </div>

          <div className="flex gap-6">
            <FilterPanel
              filters={filters}
              onFilterChange={handleFilterChange}
              onReset={handleFilterReset}
              isOpen={isFilterOpen}
              onClose={() => setIsFilterOpen(false)} />


            <div className="flex-1 min-w-0">
              <div className="mb-6">
                <SortControls
                  sortBy={sortBy}
                  onSortChange={setSortBy}
                  viewMode={viewMode}
                  onViewModeChange={setViewMode}
                  resultsCount={filteredInfluencers?.length} />

              </div>

              {compareList?.length > 0 &&
              <div className="mb-6 bg-primary/10 border border-primary rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <Icon name="GitCompare" size={20} color="var(--color-primary)" />
                      <span className="text-sm font-medium text-foreground">
                        {compareList?.length} influencer karşılaştırma için seçildi
                      </span>
                    </div>
                    <div className="flex gap-2">
                      <button
                      onClick={() => setIsComparisonOpen(true)}
                      className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium hover:bg-primary/90 transition-smooth">

                        Karşılaştır
                      </button>
                      <button
                      onClick={() => setCompareList([])}
                      className="px-4 py-2 bg-muted text-foreground rounded-md text-sm font-medium hover:bg-muted/80 transition-smooth">

                        Temizle
                      </button>
                    </div>
                  </div>
                </div>
              }

              {filteredInfluencers?.length > 0 ?
              <div className={`
                  grid gap-6
                  ${viewMode === 'grid' ? 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3' : 'grid-cols-1'}
                `
              }>
                  {filteredInfluencers?.map((influencer) =>
                <InfluencerCard
                  key={influencer?.id}
                  influencer={influencer}
                  onFavorite={handleFavorite}
                  onCompare={handleCompare}
                  isComparing={compareList?.includes(influencer?.id)}
                  onProposalClick={openProposalModal} />

                )}
                </div> :

              <div className="text-center py-16">
                  <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">
                    Sonuç Bulunamadı
                  </h3>
                  <p className="text-muted-foreground mb-6">
                    Arama kriterlerinize uygun influencer bulunamadı. Filtreleri değiştirmeyi deneyin.
                  </p>
                  <button
                  onClick={handleFilterReset}
                  className="px-6 py-2 bg-primary text-primary-foreground rounded-md font-medium hover:bg-primary/90 transition-smooth">

                    Filtreleri Sıfırla
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </main>
      <MobileNav userRole="artist" />
      <QuickActions userRole="artist" />
      {isComparisonOpen &&
      <ComparisonModal
        influencers={comparedInfluencers}
        onClose={() => setIsComparisonOpen(false)}
        onRemove={handleRemoveFromCompare} />

      }
      <ProposalModal
        isOpen={isProposalModalOpen}
        onClose={closeProposalModal}
        influencerName={selectedInfluencer?.name}
        selectedPackage={null} />
    </div>);

};

export default InfluencerDiscovery;